import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Dashboard = () => {
    const [role, setRole] = useState("");
    const [experience, setExperience] = useState("");
    const [questions, setQuestions] = useState([]);
    const [history, setHistory] = useState([]);

    const navigate = useNavigate();

    const handleGenerate = async () => {
        try {
            const userId = localStorage.getItem("userId");
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/generate` ,{
                role, experience, userId
            });

            setQuestions(res.data.questions);
        }
        catch(error) { console.log(error); alert("sending data was failed"); }
    };

    const handleLogout = async () => {
        localStorage.clear();
        navigate("/login");
    };

    return (
        <div>
            <header className="flex justify-between items-center px-6 py-4 bg-gray-900 text-white shadow-md">
                <h1 className="text-2xl font-bold cursor-pointer"> AI Interview Prep </h1>

                <nav className="space-x-6 text-lg">
                    <Link to="/dashboard" className="hover:text-green-400">Dashboard</Link>
                    <Link to="/history" className="hover:text-green-400">History</Link>
                    <button onClick={handleLogout} className="bg-red-500 px-4 py-1 rounded hover:bg-red-600"> Logout </button>
                </nav>

            </header>
            <div style={{ width: "500px", margin: "40px auto", padding: "20px", border: "1px solid #ddd", borderRadius: "10px", background: "#fff" }}>
            <h2 style={{ textAlign: "center" }}>AI Interview Dashboard</h2>
            <label>Enter Role: </label>
            <input type="text" value={role} onChange={(e) => setRole(e.target.value)} placeholder="Ex: Java Developer" style={{ width: "100%", padding: "10px", marginBottom: "10px" }} />
            <label>Experience (in years): </label>
            <input type="number" value={experience} onChange={(e) => setExperience(e.target.value)} placeholder="Ex: 2" style={{ width: "100%", padding: "10px" }} />

            <button  onClick={handleGenerate} style={{ width: "100%", marginTop: "15px", padding: "10px", background: "#4CAF50", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}> Generate Questions </button>

            <h3> Generated Questions </h3>
            {questions.map((q,i) => (
                <div key={i} style={{ marginTop: "10px", padding: "10px", border: "1px solid #ddd" }}>
                    <p> <b> Q: </b> {q.question} </p>
                    <p> <b> A: </b> {q.answer} </p>
                </div>
            ))}
            </div>
        </div>
    )
};

export default Dashboard;